module.exports = __webpack_public_path__ + "static/media/change-column-icon.9eb4f2e7.svg";